// 一覧の表示設定（密度・グループ）。ユーザー（ブラウザ）単位で localStorage に保存する。
import type { Density, GroupBy } from "./listModel";

const KEY = "gf.list.prefs";

export interface ListPrefs {
  density: Density;
  group: GroupBy;
}

const DEFAULTS: ListPrefs = { density: "normal", group: "none" };
const DENSITIES: readonly Density[] = ["normal", "compact"];
const GROUPS: readonly GroupBy[] = ["none", "camp", "stage", "act"];

export function loadListPrefs(): ListPrefs {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return DEFAULTS;
    const o = JSON.parse(raw) as Partial<ListPrefs>;
    return {
      density: o.density && DENSITIES.includes(o.density) ? o.density : DEFAULTS.density,
      group: o.group && GROUPS.includes(o.group) ? o.group : DEFAULTS.group,
    };
  } catch {
    return DEFAULTS;
  }
}

export function saveListPrefs(p: ListPrefs): void {
  try {
    window.localStorage.setItem(KEY, JSON.stringify(p));
  } catch {
    // プライベートウィンドウ等では保存できない。表示はそのまま続ける
  }
}
